import style from './commonly-used.css'

export const commonStyle = style
